export const IntlHelpers = {
    formatPrice: (price?: number | null, decimals?: number) => {
        if (price === undefined || price === null) {
            return '';
        }

        return Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        }).format(price);
    },

    formatPriceShort: (price?: number | null, fractionDigits = 0) => {
        if (price === undefined || price === null) {
            return '';
        }

        if (price >= 1000000) {
            return `$${(price / 1000000).toFixed(fractionDigits)}M`;
        }

        if (price >= 1000) {
            return `$${(price / 1000).toFixed(fractionDigits)}K`;
        }

        return IntlHelpers.formatPrice(price);
    },

    formatNumber: (number?: number | null, decimals?: number) => {
        if (number === undefined || number === null) {
            return '';
        }

        return Intl.NumberFormat('en-US', {
            style: 'decimal',
            minimumFractionDigits: decimals,
            maximumFractionDigits: decimals,
        }).format(number);
    },

    formatCount: (number: number | null = 0, singular: string, plural: string) => {
        return number === 1 ? `1 ${singular}` : `${number} ${plural}`;
    },

    formatMinutes: (minutes: number): string => {
        if (minutes === 0) return '—';
        if (minutes < 60) return `${minutes}m`;

        return `${(minutes / 60).toFixed(1)}h`;
    },
};
